import axios from "axios";
import router from "../router/index.js";
import store from "@/store";

//用户登录信息在localStroage中存放的位置
export const SESSION_LOGIN_INFO = "loginInfo";

//API请求正常，数据正常
export const API_CODE = {
  //API请求正常
  OK: 200,
  //API请求正常，数据异常
  ERR_DATA: 403,
  //API请求正常，空数据
  Err_NO_DATA: 301,
  //API请求正常，登录异常
  ERR_LOGOUT: 401,
  //token超时
  TIME_OUT: 1100003,
};

//API请求异常统一报错提示
export const API_FAILED = "网络连接异常，请稍后再试";
export const API_LOGOUT = "您的账号已在其他设备登录，请重新登录";

//开发环境
// export let API_DOMAIN = 'http://xiehui01.a6edu.net';
export let API_DOMAIN = null;

if (localStorage.dynamicConfig) {
  //使用从dist/config/dynamicConfig.js中读取的配置
  let newConfig = JSON.parse(localStorage.dynamicConfig);
  if (newConfig.server_url) {
    API_DOMAIN = newConfig.server_url;
  }
} 

// if(process.env.NODE_ENV === 'production'){
//     //正式环境地址
//     API_DOMAIN = 'http://xiehui01.a6edu.net'
// }

/*
 *api请求封装（带验证信息）
 *config.method:[必填]请求method
 *config.url :[必填]请求url
 *config.data ：请求数据
 *config.formData ：是否以formData格式提交（用于上传文件）
 *config.success(res)：请求成功回调
 *config.fail(err)：请求失败回调
 *config.done()：请求结束回调
 */

export function apiRequest(config) {
  // const loginInfo = JSON.parse(window.localStorage.getItem(SESSION_LOGIN_INFO));
  if (config.data === undefined) {
    config.data = {};
  }
  config.method = config.method || "post";
  //封装header信息
  let headers = {
    "tenant-id": 1,
    Authorization: `Bearer ${
      store.state.user.token ? store.state.user.token : null
    }`,
    // loginUid: loginInfo?loginInfo.uid : null,
    // 'access-token': loginInfo?loginInfo.token:null,
  };

  let data = null;

  //判断是否使用formData方式提交
  if (config.formData) {
    headers["Content-Typr"] = "multipart/form-data";
    data = new FormData();
    Object.keys(config.data).forEach(function (key) {
      data.append(key, config.data[key]);
    });
  } else {
    data = config.data;
  }

  //组装axios
  let axiosConfig = {
    method: config.method,
    url: API_DOMAIN + config.url,
    headers,
  };
  //判断是get还是post，并且加入发送的数据
  if (config.method === "get") {
    axiosConfig.params = data;
  } else {
    axiosConfig.data = data;
  }

  //发起请求
  axios(axiosConfig)
    .then((res) => {
      let result = res.data;
      config.done && config.done();
      // 登录超时
      //1100003 请求正常，登录异常
      if (result.code === API_CODE.TIME_OUT) {
        // console.error('登录超时:接口层', result)
        // localStorage.removeItem('token')
        // localStorage.removeItem('tokenTime')
        // store.commit('user/RESET_INFO')
        if (router.currentRoute.meta.requireAuth) {
          // router.replace('/login')
        }
      } else {
        //如果登录信息正常,则执行success的回调
        config.success && config.success(result);
      }
    })
    .catch((err) => {
      //如果接口不对或出现错误，则弹出antd的modal对话框
      console.error(API_FAILED, err);
      //执行fail的回调
      config.fail && config.fail(API_FAILED);
      //执行done的回调
      config.done && config.done();
    });
}
